import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { Fa } from "../../atoms/Icons/Fa";
import { Text } from "../../atoms/Text/Text";
import { Button } from "../../atoms/Buttons/Base";
import { LoaderIcon } from "../../atoms/Icons/LoaderIcon";
import { User } from "../../models/User";
import { Game } from "../../models/Game";
import { FriendPopupModel } from "../../models/FriendPopuModel";
import {
  GameState,
  FriendPopupType,
  FriendActionState,
} from "../../models/Enums";
import {
  ScoreGroupedByDateModel,
  ScoreGroupedByUserModel,
  FriendUserInfo,
} from "../../models/FriendModel";

import FriendService, { FriendTabs } from "../../services/Friend/FriendService";
import FriendApiService from "../../services/Friend/FriendApiService";
import {
  setFriendPopupState,
  setFriendActionState,
} from "../../store/reducers";

import { RenderUserRows } from "./RenderUserRows";
import { RenderRowsOrderByFriend } from "./RenderRowsOrderByFriend";
import { RenderRowsOrderByDate } from "./RenderRowsOrderByDate";
import { RenderFooter } from "./RenderFooter";
import { RenderHeaderTabs } from "./RenderHeaderTabs";
import { RenderSendChallenges } from "./FriendChallenge/RenderSendChallenges";
import { RenderChallengesByDate } from "./FriendChallenge/RenderChallengesByDate";
import { RenderReceivedChallenges } from "./FriendChallenge/RenderReceivedChallenges";
import { RenderReceivedChallengesByDate } from "./FriendChallenge/RenderReceivedChallengesByDate";

import {
  ChallengesAvailableOrSentModel,
  ChallengesReceivedModel,
  ChallengeStatsByDateModel,
  CreateChallengePayloadModel,
  RespondChallengePayloadModel,
} from "../../models/Challenge";
import ChallengeApiService from "../../services/Friend/ChallengeApiService";

import styles from "./FriendContainer.css";
import { RenderChallengesTabMenu } from "./RenderChallengesTabMenu";
import { isMobileDevice } from '../../../utils';

type FriendBlockUserAuthorizedProps = {
  game: Game;
  gameState: GameState;
  user: User;
  dispatch?: any;
  friendActionState: FriendActionState;
};

type FriendBlockUserAuthorizedState = {
  activeTab: FriendTabs;
  isLoading: boolean;
  listOrderByDate: ScoreGroupedByDateModel[];
  listOrderByFriend: ScoreGroupedByUserModel[];
  listGlobalFriend: FriendUserInfo[];
  listSendChallenges: ChallengeStatsByDateModel[];
  dataChallengesSendByGame: ChallengesAvailableOrSentModel;
  listReceivedChallenges: ChallengeStatsByDateModel[];
  dataChallengesReceivedByGame: ChallengesReceivedModel;
  friendCount: number;
  isLoadingComponent: boolean;
  isOpened: boolean;
  selectedGameId?: number;
  globalWagerScore: number;
  showChallengeView: boolean;
  showFriendTabMobile: boolean;
};

interface RootState {
  friendPopupState: FriendPopupModel;
  friendActionState: FriendActionState;
  gameState: GameState;
}

export const MaxCounter = 150;

class FriendBlockUserAuthorizedDumb extends React.PureComponent<
  FriendBlockUserAuthorizedProps,
  FriendBlockUserAuthorizedState
> {
  static displayName = "Friend Block User Authorized";
  state = {
    activeTab: FriendTabs.OrderByDate,
    isLoading: true,
    listOrderByDate: [],
    listOrderByFriend: [],
    listGlobalFriend: [],
    listSendChallenges: [],
    dataChallengesSendByGame: {
      friendsAvailableToChallenge: [],
      challengesSent: [],
    },
    listReceivedChallenges: [],
    dataChallengesReceivedByGame: {
      challengesReceived: [],
    },
    friendCount: 0,
    isLoadingComponent: true,
    isOpened: true,
    selectedGameId: undefined,
    globalWagerScore: 0,
    showChallengeView: false,
    showFriendTabMobile: false,
  };

  _mounted = false;

  triggerHideButton = (event: any) => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  onClickSeeButton = (event: any) => {
    const alterTab = FriendService.getAtlterTab(this.state.activeTab);
    this.loadTab(alterTab);
  };

  componentWillUnmount() {
    this._mounted = false;
  }

  scrollToView() {
    const everywhereHeader = document.querySelector(".everywhere-header");
    const PFNContainer = document.querySelector("#PFN-container");
    const headerHeight = everywhereHeader.clientHeight || 0;
    window.scrollTo({ top: PFNContainer.getBoundingClientRect().top + window.pageYOffset - headerHeight })
  }

  loadInitialTab() {
    const url = new URL((window as any).location.href);
    const PFNViewParam = url.searchParams.get("PFNView");
    const PFN2EnabledParam = url.searchParams.get("PFN2_enabled");
    const isPFN2Enabled =
      PFN2EnabledParam === "true" || this.props.game.seo_IsChallengeGame;

    if (PFN2EnabledParam === "true" || this.props.game.seo_IsChallengeGame) {
      this.setState({ showChallengeView: true });
    }

    if (PFNViewParam && isPFN2Enabled) {
      const [tab, gameIdStr] = PFNViewParam.split("_");
      const initialTabId =
        tab === "send"
          ? FriendTabs.ViewChallengeByDate
          : FriendTabs.ViewReceivedChallengeByDate;

      this.loadTab(initialTabId, parseInt(gameIdStr));
    }

    this.loadTab(FriendTabs.OrderByDate);
  }

  componentDidMount() {
    const { showChallengeView, activeTab } = this.state;
    const { game, user } = this.props;
    this._mounted = true;
    this.setState({ isLoadingComponent: false });

    this.loadInitialTab();
    this.loadFriendCounter();

    (window as any).loadSendChallengeView = (gameId) =>  {
      this.loadTab(FriendTabs.ViewChallengeByDate, gameId);
      const isMobile = isMobileDevice();
      if(isMobile){
        this.setState({showFriendTabMobile: true})
      } else {
        this.scrollToView();
      }
    };

    if (
      showChallengeView &&
      (activeTab === FriendTabs.ViewSendChallenges ||
        activeTab === FriendTabs.ViewReceivedChallenges)
    ) {
      this.loadWagerScore();
    }

    ChallengeApiService.getTotalChallengesReceived(game.slug, user).then(
      (listReceivedChallenges) => this.setState({ listReceivedChallenges })
    );

    ChallengeApiService.getTotalChallengesSent(game.slug, user).then(
      (listSendChallenges) => this.setState({ listSendChallenges })
    );
  }

  componentDidUpdate(prevProps: FriendBlockUserAuthorizedProps) {
    const { game, gameState, friendActionState } = this.props;
    const { activeTab, selectedGameId, showChallengeView } = this.state;

    const gameSavedScore =
      gameState !== prevProps.gameState &&
      gameState === GameState.GAME_SCORE_SAVED;
    const gameChanged = game.slug !== prevProps.game.slug;

    if (
      showChallengeView &&
      (activeTab === FriendTabs.ViewSendChallenges ||
        activeTab === FriendTabs.ViewReceivedChallenges)
    ) {
      this.loadWagerScore();
    }

    if (gameSavedScore || gameChanged) {
      this.loadTab(activeTab, selectedGameId, game.groupSlug);
    }

    if (friendActionState && friendActionState !== FriendActionState.Pending) {
      this.loadTab(activeTab, selectedGameId, game.groupSlug);

      if (activeTab != FriendTabs.GlobalFriend) {
        this.loadFriendCounter();
      }

      this.props.dispatch(setFriendActionState(FriendActionState.Pending));
    }
  }

  loadFriendCounter(): Promise<any> {
    return FriendApiService.getFriendList().then((list) => {
      if (this._mounted) {
        this.setState({ friendCount: list.length });
      }
    });
  }

  loadWagerScore() {
    return ChallengeApiService.getWagerSumup().then((globalWagerScore) => {
      this.setState({ globalWagerScore });
    });
  }

  createChallenge(payload: CreateChallengePayloadModel) {
    return ChallengeApiService.createChallenge(payload).then(() => {
      this.props.dispatch(
        setFriendActionState(FriendActionState.SaveChallenge)
      );
    });
  }

  dismissNotification(challengeId: number, createdByUser: boolean) {
    return ChallengeApiService.updateChallengeActivity(
      challengeId,
      createdByUser
    );
  }

  acceptDeclineChallenge(payload: RespondChallengePayloadModel) {
    return ChallengeApiService.acceptDeclineChallenge(payload).then(() => {
      this.props.dispatch(
        setFriendActionState(FriendActionState.SaveChallenge)
      );
    });
  }

  loadTab(
    friendTab: FriendTabs,
    gameId?: number,
    slug: string = this.props.game.groupSlug
  ): Promise<any> {
    this.setState({ isLoading: true });

    if (
      friendTab === FriendTabs.OrderByDate ||
      friendTab === FriendTabs.OrderByDateAll
    ) {
      return FriendApiService.getFriendLeaderboardGroupByDate(
        slug,
        friendTab === FriendTabs.OrderByDateAll
      ).then((list) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            listOrderByDate: list,
            isLoading: false,
            selectedGameId: gameId,
          });
        }
      });
    }

    if (
      friendTab === FriendTabs.OrderByFriend ||
      friendTab === FriendTabs.OrderByFriendAll
    ) {
      return FriendApiService.getFriendLeaderboardGroupByUser(
        slug,
        friendTab === FriendTabs.OrderByFriendAll
      ).then((list) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            listOrderByFriend: list,
            isLoading: false,
            selectedGameId: gameId,
          });
        }
      });
    }

    if (friendTab === FriendTabs.GlobalFriend) {
      return FriendApiService.getFriendList().then((list) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            listGlobalFriend: list,
            isLoading: false,
            selectedGameId: gameId,
          });
          this.setState({ friendCount: list.length });
        }
      });
    }

    if (friendTab === FriendTabs.ViewSendChallenges) {
      return ChallengeApiService.getTotalChallengesSent(
        this.props.game.slug,
        this.props.user
      ).then((listSendChallenges) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            listSendChallenges,
            isLoading: false,
            selectedGameId: gameId,
          });
        }
      });
    }

    if (friendTab === FriendTabs.ViewChallengeByDate) {
      return ChallengeApiService.getFriendsAvailableAndExistingSentChallengesByGame(
        this.props.game.slug,
        gameId,
        this.props.user
      ).then((dataChallengesSendByGame) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            dataChallengesSendByGame,
            isLoading: false,
            selectedGameId: gameId,
          });
        }
      });
    }

    if (friendTab === FriendTabs.ViewReceivedChallenges) {
      return ChallengeApiService.getTotalChallengesReceived(
        this.props.game.slug,
        this.props.user
      ).then((listReceivedChallenges) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            listReceivedChallenges,
            isLoading: false,
            selectedGameId: gameId,
          });
        }
      });
    }

    if (friendTab === FriendTabs.ViewReceivedChallengeByDate) {
      return ChallengeApiService.getChallengesReceivedByGame(
        this.props.game.slug,
        gameId,
        this.props.user
      ).then((dataChallengesReceivedByGame) => {
        if (this._mounted) {
          this.setState({
            activeTab: friendTab,
            dataChallengesReceivedByGame,
            isLoading: false,
            selectedGameId: gameId,
          });
        }
      });
    }

    return null;
  }

  onTabSelect(tab: FriendTabs, gameId?: number) {
    this.loadTab(tab, gameId);
  }

  onSendInvite() {
    if (this.state.friendCount >= MaxCounter) {
      this.props.dispatch(
        setFriendPopupState({
          type: FriendPopupType.MaxCounterToSend,
          friendToRemove: null,
        })
      );
    } else {
      this.props.dispatch(
        setFriendPopupState({
          type: FriendPopupType.SendInvite,
          friendToRemove: null,
          friendCount: this.state.friendCount,
        })
      );
    }
  }

  onClickRemove = (friend: FriendUserInfo) => {
    this.props.dispatch(
      setFriendPopupState({
        type: FriendPopupType.RemoveFriend,
        friendToRemove: friend,
      })
    );
  };

  render() {
    if (this.state.isLoadingComponent)
      return <LoaderIcon className={styles.loader} />;

    const {
      activeTab,
      isOpened,
      friendCount,
      isLoading,
      globalWagerScore,
      listReceivedChallenges,
      listSendChallenges,
      showChallengeView,
      showFriendTabMobile
    } = this.state;
    const { user } = this.props;

    const showMenu =
      activeTab !== FriendTabs.ViewChallengeByDate &&
      activeTab !== FriendTabs.ViewReceivedChallengeByDate;
    const minimizedHeader =
      activeTab === FriendTabs.ViewChallengeByDate ||
      activeTab === FriendTabs.ViewReceivedChallengeByDate;
    const showFooter =
      activeTab === FriendTabs.OrderByFriend ||
      activeTab === FriendTabs.OrderByFriendAll ||
      activeTab === FriendTabs.OrderByDate ||
      activeTab === FriendTabs.OrderByDateAll;
    const showChallengeTabMenu =
      activeTab === FriendTabs.ViewSendChallenges ||
      activeTab === FriendTabs.ViewReceivedChallenges;

    if (!user) {
      return null;
    }

    return (
      <section
        id="PFN-container"
        data-element-description="Private Friends Network"
        className={classNames(
          { [styles.hiddenFriendSection]: !isOpened },
          { [styles.friendSectionOnMobile]: showFriendTabMobile },
          { [styles.friendSectionOnMobilePortrait]: showFriendTabMobile && (window.innerHeight > window.innerWidth) }
        )}
      >
        {showFriendTabMobile && (
          <div
            className={styles.closeFriendSection}
            onClick={() => this.setState({ showFriendTabMobile: false })}
          >
            <Text
              key="closeSection"
              className={styles.openButton}
            >
              <Fa
                className={styles.openButtonIcon}
                icon="times"
              />
            </Text>
          </div>
        )}
        {!showFriendTabMobile && (
          <div className={styles.triggerBlock} onClick={this.triggerHideButton}>
            <Text
              key={isOpened ? "opened" : "closed"}
              className={styles.openButton}
            >
              <Fa
                className={styles.openButtonIcon}
                icon={isOpened ? "angle-up" : "angle-down"}
              />
            </Text>
          </div>
        )}
        {/* THIS IS TO KEEP CONTAINER ASPECT RATIO BASED ON IMAGE FROM DESIGN*/}
        <picture
          className={classNames([
            styles.container_bcg,
            styles.container_bcg__login,
          ])}
          dangerouslySetInnerHTML={{
            __html: `
                <source srcset="/svg/friends/board__mobile.png" media="(max-width: 676px)"/>
                <source srcset="/svg/friends/board__desktop.png" media="(min-width: 677px)"/>
                <img src="" width="100%" alt="" role="presentation"/>
            `,
          }}
        />

        <div
         className={styles.table}>
          <Header
            minimized={minimizedHeader}
            data-element-description="Private Friends Network title"
          >
            <Text size="md" bold={true} color="inverted">
              My Private Friends Network
            </Text>
          </Header>

          {isOpened && showMenu && (
            <RenderHeaderTabs
              friendCount={friendCount}
              showChallengeTab={showChallengeView}
              onSendInvite={() => this.onSendInvite()}
              onTabSelect={(tabId) => this.onTabSelect(tabId)}
              renderTab={(...props) => this.renderTab(...props)}
            />
          )}

          {isOpened && showChallengeTabMenu && (
            <div className={styles.challenge_tabs_menu_wrapper}>
              <RenderChallengesTabMenu
                tabId={activeTab}
                onTabSelect={(tab, gameId) => this.onTabSelect(tab, gameId)}
                receivedNotifications={
                  listReceivedChallenges.filter((i) => i.friendActivity).length
                }
                sendNotifications={
                  listSendChallenges.filter((i) => i.friendActivity).length
                }
              />
              <ScoreCounter score={globalWagerScore} />
            </div>
          )}

          {this.renderLBTable(activeTab)}

          {!isLoading && isOpened && showFooter && !showFriendTabMobile && (
            <RenderFooter
              tabId={activeTab}
              onClickSeeButton={this.onClickSeeButton}
            ></RenderFooter>
          )}
        </div>
      </section>
    );
  }

  renderTab(tabName: string, label: string, tabKey: FriendTabs, onClick: any) {
    let { activeTab } = this.state;

    const alterTab = FriendService.getAtlterTab(activeTab);
    const active = activeTab === tabKey || alterTab === tabKey;

    return (
      <Tab
        role="tab"
        data-element-description={label}
        aria-controls={tabKey}
        id={`tab${tabKey}`}
        aria-selected={active}
        aria-label={label}
        active={active}
        onClick={onClick}
      >
        <Text>{tabName}</Text>
      </Tab>
    );
  }

  renderLBTable(tabId: FriendTabs) {
    let {
      isOpened,
      isLoading,
      listOrderByDate,
      listOrderByFriend,
      listGlobalFriend,
      listSendChallenges,
      dataChallengesSendByGame,
      listReceivedChallenges,
      dataChallengesReceivedByGame,
    } = this.state;
    const { user, game } = this.props;

    if (isLoading) {
      return (
        <div
          className={classNames(styles.tbody__loading, {
            [styles.hiddenFriendSection]: !isOpened,
          })}
        >
          <Text
            color="accentLight"
            align="center"
            as="div"
            role="status"
            ariaLive="polite"
          >
            Loading...
          </Text>
        </div>
      );
    }

    if (
      (tabId === FriendTabs.OrderByDate && !listOrderByDate.length) ||
      (tabId === FriendTabs.OrderByFriend && !listOrderByFriend.length) ||
      (tabId === FriendTabs.GlobalFriend && !listGlobalFriend.length)
    ) {
      return (
        <div
          className={classNames(styles.tbody__list, {
            [styles.hiddenFriendSection]: !isOpened,
          })}
        >
          <Text color="accentLight" align="center" as="div">
            There are no friends result yet
          </Text>
        </div>
      );
    }

    if (tabId === FriendTabs.GlobalFriend) {
      return (
        <RenderUserRows
          list={listGlobalFriend}
          onClickRemove={this.onClickRemove}
          isOpened={isOpened}
          tabId={tabId}
        ></RenderUserRows>
      );
    }

    if (
      tabId === FriendTabs.OrderByFriend ||
      tabId === FriendTabs.OrderByFriendAll
    ) {
      return (
        <RenderRowsOrderByFriend
          list={listOrderByFriend}
          isOpened={isOpened}
          tabId={tabId}
          user={user}
        ></RenderRowsOrderByFriend>
      );
    }

    if (tabId === FriendTabs.ViewSendChallenges) {
      return (
        <RenderSendChallenges
          isOpened={isOpened}
          tabId={tabId}
          user={user}
          list={listSendChallenges}
          onTabSelect={(tab, selectedGameId) =>
            this.onTabSelect(tab, selectedGameId)
          }
        />
      );
    }

    if (tabId === FriendTabs.ViewChallengeByDate) {
      return (
        <RenderChallengesByDate
          isOpened={isOpened}
          tabId={tabId}
          user={user}
          game={game}
          data={dataChallengesSendByGame}
          onTabSelect={(tab, selectedGameId) =>
            this.onTabSelect(tab, selectedGameId)
          }
          onDismissNotification={(challengeId) =>
            this.dismissNotification(challengeId, true)
          }
          onCreateNewChallenge={(payload) => this.createChallenge(payload)}
        />
      );
    }
    if (tabId === FriendTabs.ViewReceivedChallenges) {
      return (
        <RenderReceivedChallenges
          isOpened={isOpened}
          tabId={tabId}
          user={user}
          list={listReceivedChallenges}
          onTabSelect={(tab, selectedGameId) =>
            this.onTabSelect(tab, selectedGameId)
          }
        />
      );
    }

    if (tabId === FriendTabs.ViewReceivedChallengeByDate) {
      return (
        <RenderReceivedChallengesByDate
          isOpened={isOpened}
          tabId={tabId}
          user={user}
          data={dataChallengesReceivedByGame}
          onTabSelect={(tab, selectedGameId) =>
            this.onTabSelect(tab, selectedGameId)
          }
          onRespondToChallenge={(payload) =>
            this.acceptDeclineChallenge(payload)
          }
          onDismissNotification={(challengeId) =>
            this.dismissNotification(challengeId, false)
          }
        />
      );
    }

    return (
      <RenderRowsOrderByDate
        list={listOrderByDate}
        isOpened={isOpened}
        tabId={tabId}
        user={user}
      ></RenderRowsOrderByDate>
    );
  }
}

export const FriendBlockUserAuthorized = connect((state: RootState) => ({
  friendPopupState: state.friendPopupState,
  friendActionState: state.friendActionState,
  gameState: state.gameState,
}))(FriendBlockUserAuthorizedDumb);

const Header = (props: any) => (
  <div
    className={classNames(styles.header, {
      [styles.minimized]: !!props.minimized,
    })}
    {...props}
  />
);
const Tab = ({ active, ...props }: any) => (
  <Button
    className={classNames(styles.tab, { [styles.active]: !!active })}
    {...props}
  />
);
const ScoreCounter = ({ score }: { score?: number }) => (
  <div className={styles.score_counter}>
    <Text className={styles.points}>{score}</Text>
    <Text>Wager pts. Won</Text>
  </div>
);
